"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var Price_1 = require("../Price");
var priceWithLabelStyles_1 = require("./priceWithLabelStyles");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var PriceWithLabel = function (_a) {
    var dataTest = _a.dataTest, price = _a.price, currency = _a.currency, decimals = _a.decimals, label = _a.label, priceDisplayType = _a.priceDisplayType;
    var _b;
    var style = priceWithLabelStyles_1.default();
    var showPricePrefix = (_b = core_1.useTheme().checkoutLite.summary) === null || _b === void 0 ? void 0 : _b.showPricePrefix;
    return (<core_1.Box display="flex" flexDirection="column" justifyContent={'center'} alignItems={'center'}>
      <core_1.Box className={style.pricePrefixContainer}>
        {showPricePrefix && (<core_1.Typography variant="h3" className={style.pricePrefix}>
            <Translation_1.default id="carDetails.label.pricePrefix"/>
          </core_1.Typography>)}
        <Price_1.default price={price} priceDisplayType={priceDisplayType} currency={currency} decimals={decimals} className={style.priceElement} dataTest={"" + dataTest} variant={'body1'}/>
      </core_1.Box>
      <core_1.Typography variant="caption" className={style.label} data-test={'text:price:label'}>
        {label}
      </core_1.Typography>
    </core_1.Box>);
};
exports.default = PriceWithLabel;
